import { useNavigate } from 'react-router-dom'
import { ROUTES } from '../../constants'
import CustomButton from '../../Components/CustomButton'
import './styles.scss'

const NotFound = () => {
  const navigate = useNavigate()

  return (
    <div className="not-found">
      <div className="not-found__inner">
        <div className="not-found__icon">
          <img src="/favicon.png" alt="Farze Global Logistics" />
        </div>

        <div className="not-found__code">404</div>

        <h1>Page Not Found</h1>

        <p>
          Looks like this shipment got lost in transit. The page you're looking
          for doesn't exist or has been moved.
        </p>

        <div className="not-found__actions">
          <CustomButton label="Go Home" onClick={() => navigate('/')} />
          <button className="not-found__contact" onClick={() => navigate(ROUTES.contact)}>
            Contact Us
          </button>
        </div>
      </div>
    </div>
  )
}

export default NotFound
